"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var client_1 = require("./client");
exports.SyncClient = client_1.SyncClient;
var syncdocument_1 = require("./syncdocument");
exports.SyncDocument = syncdocument_1.SyncDocument;
var synclist_1 = require("./synclist");
exports.SyncList = synclist_1.SyncList;
var listitem_1 = require("./listitem");
exports.SyncListItem = listitem_1.ListItem;
var syncmap_1 = require("./syncmap");
exports.SyncMap = syncmap_1.SyncMap;
var mapitem_1 = require("./mapitem");
exports.SyncMapItem = mapitem_1.MapItem;
exports.default = client_1.SyncClient;

module.exports = client_1.SyncClient;
module.exports.SyncClient = client_1.SyncClient;


//////////////////
// WEBPACK FOOTER
// ./node_modules/twilio-sync/browser/index.js
// module id = ./node_modules/twilio-sync/browser/index.js
// module chunks = 0